"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledTheming = _interopRequireDefault(require("styled-theming"));

var _reactNumberFormat = _interopRequireDefault(require("react-number-format"));

var _Constant = require("../../Constant");

var _Input = require("./Input");

var _InputContainer = require("./InputContainer");

var _Label = _interopRequireDefault(require("../Label"));

var _Error = _interopRequireDefault(require("../Error"));

var _util = require("../../Util/util");

var _theme, _theme2;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _templateObject5() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  /* focus-within is used to target the <label> because CSS does not have a previous sibling selector */\n  &:focus-within {\n    ", " {\n      ", "\n    }\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  margin-bottom: 0;\n  margin-top: 15px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  color: ", ";\n  margin-bottom: 0;\n  margin-top: 7px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  background-color: ", ";\n\n  && input {\n    ", "\n    border-bottom: 2px dotted;\n    border-bottom-color: ", ";\n    color: ", ";\n    font-family: ", ";\n    font-size: 2.8rem;\n    font-weight: 700;\n    height: 6.8rem;\n    margin-top: 0;\n    padding: 2rem 1.5rem 2rem 2rem;\n\n    &:focus {\n      ", "\n      /* Visible outline for high contrast mode */\n      outline: 2px solid transparent;\n      outline-offset: 4px;\n    }\n  }\n\n  @media print, screen and (min-width: ", "px) {\n    && input {\n      font-size: 4.2rem;\n      height: 7.2rem;\n      padding: 1.2rem 1.4rem;\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  color: ", ";\n  display: inline-block;\n  font-size: 1.5rem;\n  font-weight: 700;\n  letter-spacing: 0.015em;\n  line-height: 1.5;\n  margin-bottom: 8px;\n\n  @media print, screen and (min-width: ", "px) {\n    font-size: 1.8rem;\n    font-weight: 500;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

/**
 * TODO: This component was set up to support the `instruction` prop that SLR used to display instruction text.
 * When we refactor this component, we can remove the instruction-related logic.
 * Additionally, we can use the `descriptiveTextId` prop instead as we do in the other inputs.
 */
var numberTextColor = (0, _styledTheming.default)('mode', (_theme = {}, (0, _defineProperty2.default)(_theme, _Constant.Themes.HOMEBRIDGE, _Constant.Color.BLACK_SOUL), (0, _defineProperty2.default)(_theme, "homepoint", _Constant.Color.BLACK_SOUL), (0, _defineProperty2.default)(_theme, _Constant.Themes.SYNERGY_ONE, _Constant.Color.BLACK_SOUL), (0, _defineProperty2.default)(_theme, "caliber", _Constant.Color.CALIBER_GREEN), (0, _defineProperty2.default)(_theme, "figure", _Constant.Color.BLACK_SOUL), (0, _defineProperty2.default)(_theme, "petersendean", _Constant.Color.TEAL), (0, _defineProperty2.default)(_theme, "pella", _Constant.Color.TEAL), (0, _defineProperty2.default)(_theme, _Constant.Themes.GUARANTEED_RATE, _Constant.Color.GUARANTEED_RATE_RAVENSWOOD_GRAY), _theme));
var sliderBorder = (0, _styledTheming.default)('mode', (_theme2 = {}, (0, _defineProperty2.default)(_theme2, _Constant.Themes.HOMEBRIDGE, _Constant.Color.GREY_4), (0, _defineProperty2.default)(_theme2, "homepoint", _Constant.Color.BLACK_SOUL), (0, _defineProperty2.default)(_theme2, _Constant.Themes.SYNERGY_ONE, _Constant.Color.SYNERGY_ONE_YELLOW_DARK), (0, _defineProperty2.default)(_theme2, "caliber", _Constant.Color.CALIBER_GREEN), (0, _defineProperty2.default)(_theme2, "figure", _Constant.Color.GREY_4), (0, _defineProperty2.default)(_theme2, "petersendean", _Constant.Color.TEAL), (0, _defineProperty2.default)(_theme2, "pella", _Constant.Color.TEAL), (0, _defineProperty2.default)(_theme2, _Constant.Themes.GUARANTEED_RATE, _Constant.Color.GUARANTEED_RATE_ARROW_RED), _theme2));
var Label = (0, _styledComponents.default)(_Label.default)(_templateObject(), _Constant.Color.BLACK_SOUL, _Constant.Width.SM);

var InputWrapper = _styledComponents.default.div(_templateObject2(), _Constant.Color.GREY_1, _Input.inputStyles, function (props) {
  return props.color !== '' ? props.color : sliderBorder;
}, function (props) {
  return props.color !== '' ? props.color : numberTextColor;
}, _Constant.Font.SECONDARY_HEADER_FONT, _Input.focusStyles, _Constant.Width.SM);

var Instruction = _styledComponents.default.p(_templateObject3(), _Constant.Color.DARK_GREY_2);

var Error = (0, _styledComponents.default)(_Error.default)(_templateObject4());

var AmountInputWrapper = _styledComponents.default.div(_templateObject5(), Label, _InputContainer.modeLabelFocusStyles);

var AmountInput = function AmountInput(_ref) {
  var allowNegative = _ref.allowNegative,
      amountInputLabel = _ref.amountInputLabel,
      color = _ref.color,
      decimalScale = _ref.decimalScale,
      decimalSeparator = _ref.decimalSeparator,
      disabled = _ref.disabled,
      errorText = _ref.errorText,
      fixedDecimalScale = _ref.fixedDecimalScale,
      id = _ref.id,
      instruction = _ref.instruction,
      isHiddenLabel = _ref.isHiddenLabel,
      onChange = _ref.onChange,
      prefix = _ref.prefix,
      sliderInputErrorId = _ref.sliderInputErrorId,
      thousandSeparator = _ref.thousandSeparator,
      value = _ref.value,
      fsMask = _ref.fsMask,
      otherProps = (0, _objectWithoutProperties2.default)(_ref, ["allowNegative", "amountInputLabel", "color", "decimalScale", "decimalSeparator", "disabled", "errorText", "fixedDecimalScale", "id", "instruction", "isHiddenLabel", "onChange", "prefix", "sliderInputErrorId", "thousandSeparator", "value", "fsMask"]);

  /**
   * `aria-describedby` connects both the `instruction` and `errorText` text to the input for assistive technology users.
   * This attribute should only be added to the DOM if either or both text types are present.
   * `aria-invalid` communicates to screen reader users that an input is invalid.
   * It should only be added to the DOM when `errorText` has been passed into either the `AmountInputSlider` or this component.
   * If this component is used on its own, the errorTextId is set in this component.
   * If this component is used inside of the `SliderInput`, the id is passed down because the input needs to be linked to that component's error message.
   */
  var instructionId = instruction ? "".concat(id, "-instruction") : null;
  var amountInputErrorId = errorText ? "".concat(id, "-error") : null;
  var errorTextId = sliderInputErrorId ? sliderInputErrorId : amountInputErrorId;
  var ariaMessageIds = [instructionId, errorTextId].join(' ').trim();

  var inputProps = _objectSpread(_objectSpread({}, otherProps), {}, {
    allowNegative: allowNegative,
    'aria-describedby': ariaMessageIds !== '' ? ariaMessageIds : null,
    'aria-invalid': sliderInputErrorId || errorText ? 'true' : null,
    decimalScale: decimalScale,
    decimalSeparator: decimalSeparator,
    disabled: disabled,
    fixedDecimalScale: fixedDecimalScale,
    id: id,
    onValueChange: function onValueChange(_ref2) {
      var value = _ref2.value;
      return onChange((0, _util.parseNumericValue)(value));
    },
    prefix: prefix,
    thousandSeparator: thousandSeparator,
    type: 'tel',
    value: value
  });

  return /*#__PURE__*/_react.default.createElement(AmountInputWrapper, null, /*#__PURE__*/_react.default.createElement(Label, {
    htmlFor: id,
    isVisuallyHidden: isHiddenLabel
  }, amountInputLabel), /*#__PURE__*/_react.default.createElement(InputWrapper, {
    color: color,
    className: fsMask ? 'fs-mask' : ''
  }, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, inputProps)), instruction && /*#__PURE__*/_react.default.createElement(Instruction, {
    id: instructionId
  }, instruction), errorText && /*#__PURE__*/_react.default.createElement(Error, {
    display: "block",
    id: amountInputErrorId
  }, errorText));
};

AmountInput.propTypes = {
  /** Whether or not to allow a negative number */
  allowNegative: _propTypes.default.bool,

  /** The label for the input */
  amountInputLabel: _propTypes.default.string.isRequired,

  /** Color of slider value */
  color: _propTypes.default.string,

  /** If defined it limits to given decimal scale */
  decimalScale: _propTypes.default.number,

  /** Support decimal point on a number */
  decimalSeparator: _propTypes.default.string,

  /** Whether or not to disable the input */
  disabled: _propTypes.default.bool,

  /** Error message text */
  errorText: _propTypes.default.string,

  /** If true it add 0s to match given decimalScale */
  fixedDecimalScale: _propTypes.default.bool,

  /** The id for the number input */
  id: _propTypes.default.string.isRequired,

  /** A string of informational text */
  instruction: _propTypes.default.string,

  /** Ideally, label text is always visible.
   * If necessary, this prop will hide label text from sighted users while still making it available to assistive technology.
   * It will not hide error text.
   */
  isHiddenLabel: _propTypes.default.bool,

  /** onChange will be triggered while the value of Slider changing. */
  onChange: _propTypes.default.func.isRequired,

  /** Prefix of the number */
  prefix: _propTypes.default.string,

  /** ID passed from SliderInput that links this input to the SliderInput's error message */
  sliderInputErrorId: _propTypes.default.string,

  /** Add thousand separators on number. Accepts only true as boolean, or a separator string */
  thousandSeparator: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),

  /** Value for the number input  */
  value: _propTypes.default.number,

  /** Toggles masking input within FullStory */
  fsMask: _propTypes.default.bool
};
AmountInput.defaultProps = {
  allowNegative: false,
  color: '',
  decimalScale: 0,
  decimalSeparator: '.',
  disabled: false,
  errorText: '',
  fixedDecimalScale: true,
  instruction: '',
  isHiddenLabel: false,
  prefix: '$',
  sliderInputErrorId: null,
  thousandSeparator: true,
  value: undefined,
  fsMask: true
};
var _default = AmountInput;
exports.default = _default;